// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MainPage__root--ikoX {
    --border-radius: 12px;

    max-width: 960px;
    margin: 0 auto;
}

.MainPage__section--bfk5 {
    padding: 24px;
    border: 4px solid var(--obscure-color);
    background-color: var(--tertiary-color);
    border-radius: var(--border-radius);
    margin-bottom: 32px;
}

.MainPage__section--bfk5 .MainPage__title--siMy,
    .MainPage__section--bfk5 .MainPage__description--p5tq {
        text-align: center;
    }

.MainPage__section--bfk5 .MainPage__description--p5tq {
        max-width: 608px;
        margin-right: auto;
        margin-left: auto;
    }

.MainPage__secondarySection--u6dL {
    border: 4px solid var(--obscure-color);
    background-color: var(--tertiary-color);
    border-radius: var(--border-radius);
    margin-bottom: 32px;
    padding: 24px 0;
}

.MainPage__secondarySection--u6dL .MainPage__title--siMy,
    .MainPage__secondarySection--u6dL .MainPage__description--p5tq {
        text-align: center;
    }

.MainPage__secondarySection--u6dL .MainPage__description--p5tq,
    .MainPage__secondarySection--u6dL .MainPage__title--siMy {
        max-width: 608px;
        margin-right: auto;
        margin-left: auto;
    }

.MainPage__secondarySection--u6dL.MainPage__withIndent--h8Sj {
        padding: 24px;
    }

.MainPage__secondarySection--u6dL.MainPage__withIndentChildren--oTdl .MainPage__description--p5tq,
    .MainPage__secondarySection--u6dL.MainPage__withIndentChildren--oTdl .MainPage__title--siMy {
        padding: 0 24px;
        max-width: 656px;
    }

.MainPage__tertiarySection--CDPj {
    max-width: 632px;
    border: 4px solid var(--obscure-color);
    background-color: var(--tertiary-color);
    border-radius: var(--border-radius);
    margin-bottom: 24px;
    padding: 24px;
}

.MainPage__title--siMy {
    margin-bottom: 4px;
    font-size: 26px;
    line-height: 34px;
    font-weight: 700;
    color: var(--darkest-color);
}

.MainPage__secondaryTitle--yir7 {
    margin-bottom: 16px;
    font-size: 26px;
    line-height: 34px;
    font-weight: 700;
    color: var(--darkest-color);
}

.MainPage__tertiaryTitle--TMzr {
    margin-bottom: 16px;
    font-size: 24px;
    line-height: 32px;
    font-weight: 700;
    color: var(--secondary-color);
}

.MainPage__description--p5tq {
    font-size: 15px;
    line-height: 20px;
    font-weight: 400;
    color: var(--darkest-color);
    margin-bottom: 24px;
}

.MainPage__description--p5tq > strong {
        font-weight: 700;
    }

.MainPage__form--JKy1 {
    max-width: 608px;
    margin-right: auto;
    margin-left: auto;
    display: flex;
    flex-direction: column;
    gap: 16px;
}

@media screen and (min-width: 1024px), screen and (min-width: 768px) and (max-width: 1024px) {

.MainPage__form--JKy1 {
        display: grid;
        grid-template-columns: auto 108px;
        grid-gap: 16px
}
    }

.MainPage__input--zx4f input {
        border-radius: 48px;
    }

.MainPage__button--zLGc {
    border-radius: 42px;
}

.MainPage__trackedEmailList--IzHt {
    display: flex;
    flex-direction: column;
}

.MainPage__trackedEmailItem--hh2K {
    background-color: var(--main-light-color);
    padding: 24px;
    border-bottom: 1px solid var(--obscure-color);
    display: flex;
    flex-direction: column;
    gap: 24px;
}

.MainPage__trackedEmailItem--hh2K:first-child {
        border-top: 1px solid var(--obscure-color);
    }

@media screen and (min-width: 1024px), screen and (min-width: 768px) and (max-width: 1024px) {

.MainPage__trackedEmailItem--hh2K {
        padding: 32px;
        display: grid;
        grid-template-columns: max-content 1px auto 1px max-content;
        grid-gap: 24px
}
    }

.MainPage__trackedEmailItemDetails--dYHF {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.MainPage__divider--YPAF {
    background-color: var(--obscure-color);
    width: 100%;
    height: 1px;
}

@media screen and (min-width: 1024px), screen and (min-width: 768px) and (max-width: 1024px) {

.MainPage__divider--YPAF {
        width: 1px;
        height: auto
}
    }

.MainPage__trackedEmailItemInformation--PNla {
    display: flex;
    align-items: center;
    gap: 8px;
    font-weight: 600;
    font-style: italic;
    font-size: 18px;
    line-height: 24px;
    color: var(--secondary-color);
}

.MainPage__trackedEmailItemInformation--PNla > svg {
        width: 12px;
        height: 12px;
        color: var(--gray-color);
    }

.MainPage__breachDetails--Twy1 {
    display: grid;
    grid-template-columns: auto max-content;
    grid-gap: 12px;
}

@media screen and (min-width: 1024px), screen and (min-width: 768px) and (max-width: 1024px) {

.MainPage__breachDetails--Twy1 {
        grid-gap: 24px;
        grid-template-columns: 1fr 1fr
}
    }

.MainPage__breachDetailsItem--c2uD {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    color: var(--secondary-color);
}

.MainPage__breachDetailsItem--c2uD > span:first-child {
        font-weight: 600;
        font-size: 15px;
        line-height: 20px;
    }

.MainPage__breachDetailsItem--c2uD > span:last-child {
        font-weight: 700;
        font-size: 24px;
        line-height: 32px;
    }

@media screen and (min-width: 1024px), screen and (min-width: 768px) and (max-width: 1024px) {

.MainPage__breachDetailsItem--c2uD {
        align-items: center
}
    }

.MainPage__list--J4tP {
    display: flex;
    flex-direction: column;
    gap: 24px;
}

@media screen and (min-width: 1024px) {

.MainPage__list--J4tP {
        display: grid;
        grid-template-columns: 1fr 1fr;
        grid-gap: 24px
}
    }

.MainPage__listItem--oTto {
    border-radius: 12px;
    border: 1px solid var(--obscure-color);
    padding: 16px;
    background-color: var(--main-light-color);
    color: var(--secondary-color);
    display: flex;
    flex-direction: column;
    gap: 4px;
}

.MainPage__listItem--oTto > span:first-child {
        font-weight: 600;
        font-size: 16px;
        line-height: 24px;
    }

.MainPage__listItem--oTto > span:last-child {
        font-weight: 700;
        font-size: 24px;
        line-height: 32px;
    }

.MainPage__loader--JZsU {
    margin: 24px auto;
    display: block;
}

.MainPage__smallImage--AfJf {
    width: 40px;
    height: 40px;
    padding: 8px;
    background-color: var(--secondary-color);
    border-radius: 50%;
    display: block;
    margin-bottom: 16px;
}

.MainPage__featureList--p0jC {
    display: flex;
    flex-direction: column;
    gap: 16px;
    max-width: 632px;
}

.MainPage__featureList--p0jC > li {
        color: var(--secondary-color);
    }

.MainPage__featureList--p0jC > li > p:first-child {
            font-weight: 700;
            font-size: 18px;
            line-height: 20px;
            margin-bottom: 12px;
        }

.MainPage__featureList--p0jC > li > p:last-child {
            font-weight: 400;
            font-size: 15px;
            line-height: 20px;        
        }

`, "",{"version":3,"sources":["webpack://./src/ui/pages/MainPage/MainPage.css"],"names":[],"mappings":"AAAA;IACI,qBAAqB;;IAErB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,sCAAsC;IACtC,uCAAuC;IACvC,mCAAmC;IACnC,mBAAmB;AAYvB;;AAVI;;QAEI,kBAAkB;IACtB;;AAEA;QACI,gBAAgB;QAChB,kBAAkB;QAClB,iBAAiB;IACrB;;AAGJ;IACI,sCAAsC;IACtC,uCAAuC;IACvC,mCAAmC;IACnC,mBAAmB;IACnB,eAAe;AAuBnB;;AArBI;;QAEI,kBAAkB;IACtB;;AAEA;;QAEI,gBAAgB;QAChB,kBAAkB;QAClB,iBAAiB;IACrB;;AAEA;QACI,aAAa;IACjB;;AAEA;;QAEI,eAAe;QACf,gBAAgB;IACpB;;AAGJ;IACI,gBAAgB;IAChB,sCAAsC;IACtC,uCAAuC;IACvC,mCAAmC;IACnC,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,2BAA2B;AAC/B;;AAEA;IACI,mBAAmB;IACnB,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,2BAA2B;AAC/B;;AAEA;IACI,mBAAmB;IACnB,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,6BAA6B;AACjC;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,2BAA2B;IAC3B,mBAAmB;AAKvB;;AAHI;QACI,gBAAgB;IACpB;;AAGJ;IACI,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,SAAS;AAOb;;AALI;;AARJ;QASQ,aAAa;QACb,iCAAiC;QACjC;AAER;IADI;;AAIA;QACI,mBAAmB;IACvB;;AAGJ;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,yCAAyC;IACzC,aAAa;IACb,6CAA6C;IAC7C,aAAa;IACb,sBAAsB;IACtB,SAAS;AAYb;;AAVI;QACI,0CAA0C;IAC9C;;AAEA;;AAZJ;QAaQ,aAAa;QACb,aAAa;QACb,2DAA2D;QAC3D;AAER;IADI;;AAGJ;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,sCAAsC;IACtC,WAAW;IACX,WAAW;AAMf;;AAJI;;AALJ;QAMQ,UAAU;QACV;AAER;IADI;;AAGJ;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,6BAA6B;AAOjC;;AALI;QACI,WAAW;QACX,YAAY;QACZ,wBAAwB;IAC5B;;AAGJ;IACI,aAAa;IACb,uCAAuC;IACvC,cAAc;AAMlB;;AAJI;;AALJ;QAMQ,cAAc;QACd;AAER;IADI;;AAGJ;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,6BAA6B;AAiBjC;;AAfI;QACI,gBAAgB;QAChB,eAAe;QACf,iBAAiB;IACrB;;AAEA;QACI,gBAAgB;QAChB,eAAe;QACf,iBAAiB;IACrB;;AAEA;;AAlBJ;QAmBQ;AAER;IADI;;AAGJ;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AAOb;;AALI;;AALJ;QAMQ,aAAa;QACb,8BAA8B;QAC9B;AAER;IADI;;AAGJ;IACI,mBAAmB;IACnB,sCAAsC;IACtC,aAAa;IACb,yCAAyC;IACzC,6BAA6B;IAC7B,aAAa;IACb,sBAAsB;IACtB,QAAQ;AAaZ;;AAXI;QACI,gBAAgB;QAChB,eAAe;QACf,iBAAiB;IACrB;;AAEA;QACI,gBAAgB;QAChB,eAAe;QACf,iBAAiB;IACrB;;AAGJ;IACI,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,wCAAwC;IACxC,kBAAkB;IAClB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,gBAAgB;AAkBpB;;AAhBI;QACI,6BAA6B;IAcjC;;AAZI;YACI,gBAAgB;YAChB,eAAe;YACf,iBAAiB;YACjB,mBAAmB;QACvB;;AAEA;YACI,gBAAgB;YAChB,eAAe;YACf,iBAAiB;QACrB","sourcesContent":[".root {\n    --border-radius: 12px;\n\n    max-width: 960px;\n    margin: 0 auto;\n}\n\n.section {\n    padding: 24px;\n    border: 4px solid var(--obscure-color);\n    background-color: var(--tertiary-color);\n    border-radius: var(--border-radius);\n    margin-bottom: 32px;\n\n    .title,\n    .description {\n        text-align: center;\n    }\n\n    .description {\n        max-width: 608px;\n        margin-right: auto;\n        margin-left: auto;\n    }\n}\n\n.secondarySection {\n    border: 4px solid var(--obscure-color);\n    background-color: var(--tertiary-color);\n    border-radius: var(--border-radius);\n    margin-bottom: 32px;\n    padding: 24px 0;\n\n    .title,\n    .description {\n        text-align: center;\n    }\n\n    .description,\n    .title {\n        max-width: 608px;\n        margin-right: auto;\n        margin-left: auto;\n    }\n\n    &.withIndent {\n        padding: 24px;\n    }\n\n    &.withIndentChildren .description,\n    &.withIndentChildren .title {\n        padding: 0 24px;\n        max-width: 656px;\n    }\n}\n\n.tertiarySection {\n    max-width: 632px;\n    border: 4px solid var(--obscure-color);\n    background-color: var(--tertiary-color);\n    border-radius: var(--border-radius);\n    margin-bottom: 24px;\n    padding: 24px;\n}\n\n.title {\n    margin-bottom: 4px;\n    font-size: 26px;\n    line-height: 34px;\n    font-weight: 700;\n    color: var(--darkest-color);\n}\n\n.secondaryTitle {\n    margin-bottom: 16px;\n    font-size: 26px;\n    line-height: 34px;\n    font-weight: 700;\n    color: var(--darkest-color);\n}\n\n.tertiaryTitle {\n    margin-bottom: 16px;\n    font-size: 24px;\n    line-height: 32px;\n    font-weight: 700;\n    color: var(--secondary-color);\n}\n\n.description {\n    font-size: 15px;\n    line-height: 20px;\n    font-weight: 400;\n    color: var(--darkest-color);\n    margin-bottom: 24px;\n\n    > strong {\n        font-weight: 700;\n    }\n}\n\n.form {\n    max-width: 608px;\n    margin-right: auto;\n    margin-left: auto;\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n\n    @media (--large), (--small-tablet) {\n        display: grid;\n        grid-template-columns: auto 108px;\n        grid-gap: 16px;\n    }\n}\n\n.input {\n    input {\n        border-radius: 48px;\n    }\n}\n\n.button {\n    border-radius: 42px;\n}\n\n.trackedEmailList {\n    display: flex;\n    flex-direction: column;\n}\n\n.trackedEmailItem {\n    background-color: var(--main-light-color);\n    padding: 24px;\n    border-bottom: 1px solid var(--obscure-color);\n    display: flex;\n    flex-direction: column;\n    gap: 24px;\n\n    &:first-child {\n        border-top: 1px solid var(--obscure-color);\n    }\n\n    @media (--large), (--small-tablet) {\n        padding: 32px;\n        display: grid;\n        grid-template-columns: max-content 1px auto 1px max-content;\n        grid-gap: 24px;\n    }\n}\n\n.trackedEmailItemDetails {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n}\n\n.divider {\n    background-color: var(--obscure-color);\n    width: 100%;\n    height: 1px;\n\n    @media (--large), (--small-tablet) {\n        width: 1px;\n        height: auto;\n    }\n}\n\n.trackedEmailItemInformation {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    font-weight: 600;\n    font-style: italic;\n    font-size: 18px;\n    line-height: 24px;\n    color: var(--secondary-color);\n\n    > svg {\n        width: 12px;\n        height: 12px;\n        color: var(--gray-color);\n    }\n}\n\n.breachDetails {\n    display: grid;\n    grid-template-columns: auto max-content;\n    grid-gap: 12px;\n\n    @media (--large), (--small-tablet) {\n        grid-gap: 24px;\n        grid-template-columns: 1fr 1fr;\n    }\n}\n\n.breachDetailsItem {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    color: var(--secondary-color);\n\n    > span:first-child {\n        font-weight: 600;\n        font-size: 15px;\n        line-height: 20px;\n    }\n\n    > span:last-child {\n        font-weight: 700;\n        font-size: 24px;\n        line-height: 32px;\n    }\n\n    @media (--large), (--small-tablet) {\n        align-items: center;\n    }\n}\n\n.list {\n    display: flex;\n    flex-direction: column;\n    gap: 24px;\n\n    @media (--large) {\n        display: grid;\n        grid-template-columns: 1fr 1fr;\n        grid-gap: 24px;\n    }\n}\n\n.listItem {\n    border-radius: 12px;\n    border: 1px solid var(--obscure-color);\n    padding: 16px;\n    background-color: var(--main-light-color);\n    color: var(--secondary-color);\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n\n    > span:first-child {\n        font-weight: 600;\n        font-size: 16px;\n        line-height: 24px;\n    }\n\n    > span:last-child {\n        font-weight: 700;\n        font-size: 24px;\n        line-height: 32px;\n    }\n}\n\n.loader {\n    margin: 24px auto;\n    display: block;\n}\n\n.smallImage {\n    width: 40px;\n    height: 40px;\n    padding: 8px;\n    background-color: var(--secondary-color);\n    border-radius: 50%;\n    display: block;\n    margin-bottom: 16px;\n}\n\n.featureList {\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n    max-width: 632px;\n\n    > li {\n        color: var(--secondary-color);\n\n        > p:first-child {\n            font-weight: 700;\n            font-size: 18px;\n            line-height: 20px;\n            margin-bottom: 12px;\n        }\n    \n        > p:last-child {\n            font-weight: 400;\n            font-size: 15px;\n            line-height: 20px;        \n        }\n    }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `MainPage__root--ikoX`,
	"section": `MainPage__section--bfk5`,
	"title": `MainPage__title--siMy`,
	"description": `MainPage__description--p5tq`,
	"secondarySection": `MainPage__secondarySection--u6dL`,
	"withIndent": `MainPage__withIndent--h8Sj`,
	"withIndentChildren": `MainPage__withIndentChildren--oTdl`,
	"tertiarySection": `MainPage__tertiarySection--CDPj`,
	"secondaryTitle": `MainPage__secondaryTitle--yir7`,
	"tertiaryTitle": `MainPage__tertiaryTitle--TMzr`,
	"form": `MainPage__form--JKy1`,
	"input": `MainPage__input--zx4f`,
	"button": `MainPage__button--zLGc`,
	"trackedEmailList": `MainPage__trackedEmailList--IzHt`,
	"trackedEmailItem": `MainPage__trackedEmailItem--hh2K`,
	"trackedEmailItemDetails": `MainPage__trackedEmailItemDetails--dYHF`,
	"divider": `MainPage__divider--YPAF`,
	"trackedEmailItemInformation": `MainPage__trackedEmailItemInformation--PNla`,
	"breachDetails": `MainPage__breachDetails--Twy1`,
	"breachDetailsItem": `MainPage__breachDetailsItem--c2uD`,
	"list": `MainPage__list--J4tP`,
	"listItem": `MainPage__listItem--oTto`,
	"loader": `MainPage__loader--JZsU`,
	"smallImage": `MainPage__smallImage--AfJf`,
	"featureList": `MainPage__featureList--p0jC`
};
export default ___CSS_LOADER_EXPORT___;
